import styled from 'styled-components'

import type { Props } from './types'

export const SIZE = {
  small: 200,
  medium: 264,
  large: 296,
  xlarge: 400,
}

type ContainerProps = Pick<Props, 'size'>

export const Container = styled.div<ContainerProps>`
  min-width: ${({ size }) => SIZE[size]}px;
  border: 1px solid var(--border-secondary);
  background: var(--bg-primary);
  border-radius: var(--radius-brand);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  padding: var(--space-100);
`
